import ButtonClipboardCopy from './ButtonClipboardCopy';
import './ButtonClipboardCopy.scss';

export default ButtonClipboardCopy;
